import {
  LOADING_TOGGLE_ACTION,
  LOGIN_CONFIRMED_ACTION,
  LOGIN_FAILED_ACTION,
  LOGOUT_ACTION,
  SIGNUP_CONFIRMED_ACTION,
  SIGNUP_FAILED_ACTION,
  PASSWORD_CHANGE_REQUIRED,
  PASSWORD_CHANGE_SUCCESS,
  PASSWORD_CHANGE_FAILED,
  PASSWORD_RESET_REQUEST_SUCCESS,
  PASSWORD_RESET_REQUEST_FAILED,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_RESET_FAILED,
} from '../actions/AuthActions';

const initialState = {
  auth: {
    email: '',
    idToken: '',
    localId: '',
    id: '',
    expiresIn: '',
    refreshToken: '',
    isSuperAdmin: false,  // Add this
    profileIds: '',  // Add this
  },
  errorMessage: '',
  successMessage: '',
  showLoading: false,
  sideMenu: false,
  passwordChangeRequired: false,
  pendingEmail: '',
};

export function AuthReducer(state = initialState, action) {
  if (action.type === SIGNUP_CONFIRMED_ACTION) {
    return {
      ...state,
      auth: action.payload,
      errorMessage: '',
      successMessage: 'Signup Successfully Completed',
      showLoading: false,
      passwordChangeRequired: false,
    };
  }

 if (action.type === LOGIN_CONFIRMED_ACTION) {
    return {
      ...state,
      auth: {
        ...action.payload,
        // Ensure all required fields are present
        profiles: action.payload.profiles || [],
        hasAccess: action.payload.hasAccess || true,
        userType: action.payload.userType || (action.payload.isSuperAdmin ? 'superadmin' : 'user'),
      },
      errorMessage: '',
      successMessage: 'Login Successfully Completed',
      showLoading: false,
      passwordChangeRequired: false,
      pendingEmail: '',
    };
  }

  if (action.type === LOGOUT_ACTION) {
    return {
      ...state,
      errorMessage: '',
      successMessage: '',
      passwordChangeRequired: false,
      pendingEmail: '',
      auth: {
        email: '',
        idToken: '',
        localId: '',
        expiresIn: '',
        refreshToken: '',
      },
    };
  }

  if (action.type === SIGNUP_FAILED_ACTION || action.type === LOGIN_FAILED_ACTION) {
    return {
      ...state,
      errorMessage: action.payload,
      successMessage: '',
      showLoading: false,
      passwordChangeRequired: false,
    };
  }

  if (action.type === LOADING_TOGGLE_ACTION) {
    return {
      ...state,
      showLoading: action.payload,
    };
  }

  if (action.type === PASSWORD_CHANGE_REQUIRED) {
    return {
      ...state,
      passwordChangeRequired: true,
      pendingEmail: action.payload.email || '',
      errorMessage: action.payload.message || 'Password change required',
      successMessage: '',
      showLoading: false,
    };
  }

  if (action.type === PASSWORD_CHANGE_SUCCESS) {
    return {
      ...state,
      passwordChangeRequired: false,
      pendingEmail: '',
      errorMessage: '',
      successMessage: action.payload,
      showLoading: false,
    };
  }

  if (action.type === PASSWORD_CHANGE_FAILED) {
    return {
      ...state,
      errorMessage: action.payload,
      successMessage: '',
      showLoading: false,
    };
  }

  if (action.type === PASSWORD_RESET_REQUEST_SUCCESS) {
    return {
      ...state,
      errorMessage: '',
      successMessage: action.payload,
      showLoading: false,
    };
  }

  if (action.type === PASSWORD_RESET_REQUEST_FAILED) {
    return {
      ...state,
      errorMessage: action.payload,
      successMessage: '',
      showLoading: false,
    };
  }

  if (action.type === PASSWORD_RESET_SUCCESS) {
    return {
      ...state,
      errorMessage: '',
      successMessage: action.payload,
      showLoading: false,
    };
  }

  if (action.type === PASSWORD_RESET_FAILED) {
    return {
      ...state,
      errorMessage: action.payload,
      successMessage: '',
      showLoading: false,
    };
  }

  return state;
}
